﻿.edit-agenda-item-form {
  &.break {
    .form-group {
      display: none;

      &.title,
      &.type,
      &.duration {
        display: block;
      }
    }
  }

  &.category {
    .form-group {
      display: none;

      &.title,
      &.type {
        display: block;
      }
    }
  }
}
